import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";


export default function Sezione3popup3({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Consolidation Area", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Consolidation Area"
    >
      <div
        className="
          relative w-full md:w-[1280px] bg-white shadow-2xl
          max-h-[90vh] overflow-y-auto overscroll-contain
        "
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
      >
        {/* Azioni in alto */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("Sezione3popup3")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Contenuto */}
        <div className="p-8 text-[16px] md:text-[26px]">
            <p>
                <b>Born in 1828,</b> Reale Mutua is the <b>largest Italian mutual insurance company and is the parent company of Reale Group.</b>
            </p>
            <p>
                The company's mission is closely tied to its <b>mutualistic nature:</b> always placing members/policyholders at the center of its attention, ensuring them quality and certainty of services.
            </p>
            <p>
                In a mutual insurance company, <b>the client who subscribes to a policy also becomes a member.</b> The mutualistic form provides the possibility of recognizing <b>"mutualistic benefits"</b> to members/policyholders, distributed in two ways:
                <ul className="list-disc pl-6 md:pl-8 pt-2">
                  <li>As <b>immediate</b> benefits, in the form of performance improvements and/or premium reductions (mutuality benefits);</li>
                  <li>As <b>deferred</b> benefits, in the form of refunds (recognition of part of the surplus achieved by the company).</li>
                </ul>                
            </p>
            <p>
              The closeness to its members/policyholders is also manifested through social responsibility initiatives.
            </p>
            <p>
                <b>Sustainability is, in fact, a fundamental value for Reale Mutua, </b> which has always adopted an ethical and transparent management of its business, supports the development of cultural activities, and is committed to the environment, social protection, people, and the community. This context includes the decision, <b>in 2022, to acquire the status of a Benefit Corporation.</b>
            </p>
        </div>

        </div>
    </div>,
    document.body
  );
}
